<div class="token-panel">
    <header class="security-section__header">
        <div>
            <h3>{{ 'app.profileSettings.securityCards.tokens.title' | translate }}</h3>
            <p>{{ 'app.profileSettings.securityCards.tokens.description' | translate }}</p>
        </div>
        <button type="button" class="safegpt-button" (click)="openCreateModal()">
            <span aria-hidden="true">+</span>
            {{ 'app.profileSettings.securityModal.tokens.newTokenFull' | translate }}
        </button>
    </header>

    @if (generatedTokenValue()) {
    <div class="token-panel__generated">
        <label for="generatedToken">{{ 'app.profileSettings.securityModal.tokens.generatedToken' | translate }}</label>
        <textarea id="generatedToken" cdkTextareaAutosize #autosize="cdkTextareaAutosize" [cdkAutosizeMinRows]="3"
            [cdkAutosizeMaxRows]="10" [value]="generatedTokenValue()" readonly></textarea>
    </div>
    }

    <div class="token-table">
        <div class="token-table__head token-table__row">
            <div>{{ 'app.profileSettings.securityModal.tokens.nameColumn' | translate }}</div>
            <div>{{ 'app.profileSettings.securityModal.tokens.expiresOn' | translate }}</div>
            <div>{{ 'app.profileSettings.securityModal.tokens.lastUsed' | translate }}</div>
            <div>{{ 'common.table.actions' | translate }}</div>
        </div>

        @for (token of filteredTokens(); track token.userApiTokenId) {
        <div class="token-table__row token-table__row--body">
            <div class="token-identity">
                <span class="token-identity__icon">
                    <app-icon icon="icon-key-regular.svg" color="currentColor" />
                </span>
                <div class="token-name">{{ token.description ||
                    ('common.noDescription' | translate) }}</div>
            </div>

            <div>
                <div>{{ token.expireAt | date: 'dd-MM-yyyy' }}</div>
                @if (isTokenExpired(token)) {
                <span class="date-badge date-badge--expired">{{ token.expireAt | date: 'dd MMM yyyy' }}</span>
                }
            </div>

            <div>
                @if (token.lastUsed) {
                {{ token.lastUsed | date: 'dd-MM-yyyy, HH:mm' }}
                } @else {
                {{ 'app.profileSettings.securityModal.tokens.neverUsed' | translate }}
                }
            </div>

            <div class="token-actions">
                <button type="button" class="icon-button"
                    [attr.aria-label]="'app.profileSettings.securityModal.tokens.rotate' | translate"
                    [attr.title]="'app.profileSettings.securityModal.tokens.rotate' | translate"
                    (click)="rotateToken.emit(token.userApiTokenId)">
                    <app-icon icon="icon-reload-regular.svg" color="currentColor" />
                </button>
                <button type="button" class="icon-button icon-button--danger"
                    [attr.aria-label]="'app.profileSettings.securityModal.tokens.delete' | translate"
                    (click)="deleteToken.emit(token.userApiTokenId)">
                    <app-icon icon="icon-trash-regular.svg" color="currentColor" />
                </button>
            </div>
        </div>
        }

        @if (filteredTokens().length === 0) {
        <div class="token-table__empty">
            {{ 'app.profileSettings.securityModal.tokens.noResults' | translate }}
        </div>
        }
    </div>

    <div class="token-panel__security-note">
        <app-icon icon="icon-lock-regular.svg" color="currentColor" />
        <div>
            <p>{{ 'app.profileSettings.securityModal.tokens.keepSafeNotice' | translate }}</p>
            <a href="https://support.safegpt.nl" target="_blank" rel="noreferrer">
                {{ 'app.profileSettings.securityModal.tokens.readMore' | translate }}
            </a>
        </div>
    </div>

    <footer class="token-panel__footer">
        <button type="button" class="safegpt-button inverted" (click)="cancelled.emit()">
            {{ 'common.actions.back' | translate }}
        </button>
    </footer>

    @if (createModalOpen()) {
    <div class="token-create-backdrop" (mousedown)="onCreateBackdropClick($event)">
        <dialog class="token-create-panel" open>
            <header class="token-create-panel__header">
                <div>
                    <h5>{{ 'app.profileSettings.securityModal.tokens.newTokenModalTitle' | translate }}</h5>
                    <p>{{ 'app.profileSettings.securityModal.tokens.newTokenModalSubtitle' | translate }}</p>
                </div>
                <button type="button" class="token-create-modal__close" (click)="closeCreateModal()"
                    [attr.aria-label]="'common.actions.close' | translate">x</button>
            </header>

            <div class="token-create-panel__content">
                <div class="field">
                    <label for="tokenName">{{ 'app.profileSettings.securityModal.tokens.tokenName' | translate
                        }}</label>
                    <input id="tokenName" name="tokenName" type="text" [ngModel]="tokenCreateModel().description"
                        (ngModelChange)="tokenCreateModel().description = $event"
                        [placeholder]="'app.profileSettings.securityModal.tokens.tokenNamePlaceholder' | translate" />
                    <small>{{ 'app.profileSettings.securityModal.tokens.tokenNameHelp' | translate }}</small>
                </div>

                <div class="field">
                    <div class="field__label">{{ 'app.profileSettings.securityModal.tokens.expiresAt' | translate }}</div>
                    <app-date-picker [value]="getExpireAtDate()" [min]="minExpireDate"
                        [ariaLabel]="'app.profileSettings.securityModal.tokens.expiresAt' | translate"
                        (valueChange)="onExpireAtChange($event)" />
                </div>

                <div class="token-permissions">
                    <div class="token-permissions__label">{{ 'app.profileSettings.securityModal.tokens.permissions' |
                        translate }}</div>
                    <div class="token-permissions__value">{{ 'app.profileSettings.securityModal.tokens.readWrite' |
                        translate }}</div>
                </div>

                <div class="token-create-panel__safe-note">
                    {{ 'app.profileSettings.securityModal.tokens.createSafeNotice' | translate }}
                </div>
            </div>

            <footer class="token-create-panel__actions">
                <button type="button" class="safegpt-button inverted" (click)="closeCreateModal()">
                    {{ 'app.confirmModal.cancel' | translate }}
                </button>
                <button type="button" class="safegpt-button" [disabled]="!tokenCreateModel().expireAt"
                    (click)="onCreateToken()">
                    {{ 'app.profileSettings.securityModal.tokens.create' | translate }}
                </button>
            </footer>
        </dialog>
    </div>
    }
</div>
